export default "__VITE_ASSET__D3_ur6BK__"